var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.weekStat.length !== 0)?_c('div',{staticClass:"endWeekWidget"},[_c('div',[_c('weekReport',{attrs:{"weekData":_vm.weekStat}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }